<template>
    <div v-if="itemCount !== 0">
        <alert-dialog headline="Wartendende Buchungen" class="mb-8">
            Es gibt
            <span v-show="itemCount === 1">eine wartende Buchung</span>
            <span v-show="itemCount > 1">{{ itemCount }} wartende Buchungen</span>
            <div class="flex justify-end">
                <button-secondary @click="showModal = true">
                    <i class="fa fa-pencil mr-2"></i>
                    Verwalte Buchungen
                </button-secondary>
            </div>
        </alert-dialog>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Verwalte Buchungen</template>

                <div v-show="bookings.length > 0" class="mb-8">
                    <tailwind-table :header="['Anforderungen', 'User', 'Zeitraum','']">
                        <tr v-for="(booking, i) in bookings" :class="{'bg-gray-50': i % 2}">
                            <td class="px-6 py-3">
                                {{ booking.bookable.name }}
                            </td>
                            <td class="px-6 py-3">
                                <span v-if="booking.user">{{ booking.user.first_name }} {{ booking.user.name }}</span>
                            </td>
                            <td class="px-6 py-3">
                                {{ booking.start | dayOfWeek }} - {{ booking.start | date }} {{ booking.start | time }} - {{ booking.end | time }} Uhr<br>
                                <span v-show="booking.comment">Anmerkung: {{ booking.comment }}</span>
                            </td>
                            <td class="px-6 py-3 text-right whitespace-nowrap">
                                <button-secondary @click="confirm(booking.id)">
                                    <i class="fa fa-check text-green-500 mr-2"></i> Bestätigen
                                </button-secondary>
                                <button-secondary @click="decline(booking.id)">
                                    <i class="fa fa-times text-red-500 mr-2"></i> Ablehnen
                                </button-secondary>
                            </td>
                        </tr>
                    </tailwind-table>
                </div>

                <div v-show="requests.length > 0" class="mb-8">
                    <tailwind-table :header="['Raum/Item', 'User', 'Zeitraum','']">
                        <bookable-request @reload="load" v-for="(request, i) in requests"
                                          :key="request.id"
                                          :class="{'bg-gray-50': i % 2}"
                                          :request="request"></bookable-request>
                    </tailwind-table>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import AlertDialog from "./UI/AlertDialog.vue";
import ButtonSecondary from "./UI/ButtonSecondary.vue";
import Modal from "./Modal.vue";
import TailwindTable from "./UI/TailwindTable.vue";
import ButtonPrimary from "./UI/ButtonPrimary.vue";
import BookableRequest from "./Bookable/BookableRequest.vue";

export default {
    name: "ManagePendingBookings",

    components: {BookableRequest, ButtonPrimary, TailwindTable, Modal, ButtonSecondary, AlertDialog},

    props: ['categoryId'],

    data: () => ({
        showModal: false,
        loading: false,
        bookings: [],
        requests: [],
    }),

    filters: {
        time(val) {
            return val.substr(11, 5);
        },
        date(val) {
            let [y, m, d] = val.substr(0, 10).split('-');
            return `${d}.${m}.${y}`;
        },
        dayOfWeek(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return new Date(`${y}-${m}-${d}`).toLocaleString('de-de', {  weekday: 'short' });
        }
    },

    computed: {
        itemCount() {
            return (this.requests.length ?? 0) + (this.bookings.length ?? 0);
        },
    },

    methods: {
        load() {
            this.loading = true;
            this.$http
                .get('/admin/pending_bookings', {params: {category: this.categoryId}})
                .then(result => {
                    this.bookings = result.data.data;
                    this.requests = result.data.requests;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        confirm(id) {
            this.updateBookingStatus(id, 'confirmed');
        },
        decline(id) {
            this.updateBookingStatus(id, 'denied');
        },
        updateBookingStatus(id, status) {
            this.loading = true;
            this.$http
                .put(`/admin/bookable_bookings/${id}`, {
                    status: status,
                })
                .then(() => {
                    if (status === 'confirmed') {
                        this.$root.$emit('alert', 'Buchung wurde bestätigt.');
                    }
                    if (status === 'denied') {
                        this.$root.$emit('alert', 'Buchung wurde abgelehnt.');
                    }

                    this.load();
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
    },
}
</script>

<style scoped>

</style>
